import { Banner } from "@shopify/polaris";
import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";

import { getMe } from "../api/me";

import { t } from "../lib/i18n";

const PLAN_LABELS: Record<string, string> = {
  free: "Free",
  starter: "Starter",
  pro: "Pro",
  business: "Business",
};

/**
 * 商品数がプラン上限を超えた店に出す常設バナー。
 * 執行自体はバックエンド（機能ルーターの 403）＝ここは案内とアップグレード導線のみ。
 * ["me"] クエリを usePlan / 各ページと共有するため追加フェッチは発生しない。
 */
export function ProductLimitBanner() {
  const navigate = useNavigate();
  const { data } = useQuery({ queryKey: ["me"], queryFn: getMe });

  const productLimit = data?.product_limit;
  if (!productLimit?.over_limit || productLimit.limit === null) {
    return null;
  }

  const requiredLabel =
    PLAN_LABELS[productLimit.required_plan_code] ?? productLimit.required_plan_code;

  return (
    <Banner
      tone="warning"
      title={t("商品数（{count}件）がプランの上限（{limit}件）を超えています", {
        count: productLimit.count.toLocaleString(),
        limit: productLimit.limit.toLocaleString(),
      })}
      action={{
        content: t("{plan} プランへアップグレード", { plan: requiredLabel }),
        onAction: () => navigate("/plans"),
      }}
    >
      <p>
        {t("データの同期は継続しています。機能のご利用には {plan}", {
          plan: requiredLabel,
        })}{" "}
        {t("プラン以上へのアップグレードが必要です（アップグレード後はそのままお使いいただけます）。")}
      </p>
    </Banner>
  );
}
